import { publicRequest } from '@/utils/request';

const baseUrl = '/api';
const baseUrl1 = '/tet';
const baseUrl2 = '/explorer/v1';

export async function getPrice() {
  return publicRequest({
    url: `${baseUrl2}/vsys/price`,
  });
}

export async function getSupply() {
  return publicRequest({
    method: 'post',
    url: `${baseUrl2}/index`,
    params: {
      name: 'home',
    },
  });
}

export async function getTET() {
  return publicRequest({
    url: `${baseUrl1}/price/token`,
  });
}

export function addressDetail(params) {
  return publicRequest({
    url: `${baseUrl}/addressDetail`,
    params,
  });
}

export function nodeDetail(params) {
  return publicRequest({
    url: `${baseUrl}/superNodesDetail`,
    params,
  });
}

export function tokensList(params) {
  return publicRequest({
    url: `${baseUrl}/getTokensList`,
    params,
  });
}
